import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import Swal from "sweetalert2";

class News extends Component {
  state = {
    news: [],
    formData: {
      id: null,
      admin_id: "",
      news_title: "",
      news_description: "",
      news_img: null,
      news_status: "1",
      news_date: "",
    },
    deleteId: null,
    error: "",
    loading: false,
    submitting: false,
    modalMode: "add",
    previewImage: null,
  };

  componentDidMount() {
    this.fetchNews();

    const modalEl = document.getElementById("newsModal");
    if (modalEl) {
      modalEl.addEventListener("hidden.bs.modal", () => {
        this.resetForm();
      });
    }
  }

  /** ✅ Fetch all news */
  fetchNews = async () => {
    this.setState({ loading: true, error: "" });
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get("/news", {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = res.data?.data || [];
      this.setState({ news: Array.isArray(data) ? data : [] });
    } catch (err) {
      this.setState({
        error:
          err.response?.data?.message ||
          "Failed to load news. Please try again.",
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  /** ✅ Reset form */
  resetForm = () => {
    this.setState({
      formData: {
        id: null,
        admin_id: "",
        news_title: "",
        news_description: "",
        news_img: null,
        news_status: "1",
        news_date: "",
      },
      previewImage: null,
      error: "",
      submitting: false,
      modalMode: "add",
    });
  };

  /** ✅ Input change */
  handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "news_img") {
      this.setState((prev) => ({
        formData: {
          ...prev.formData,
          news_img: files[0],
        },
        previewImage: files[0] ? URL.createObjectURL(files[0]) : null,
      }));
    } else {
      this.setState((prev) => ({
        formData: {
          ...prev.formData,
          [name]: value,
        },
      }));
    }
  };

  /** ✅ Open modal */
  openModal = (mode = "add", item = null) => {
    const modal = new window.bootstrap.Modal(
      document.getElementById("newsModal")
    );

    if (mode === "edit" && item) {
      this.setState({
        modalMode: "edit",
        formData: {
          id: item.id,
          admin_id: item.admin_id || "",
          news_title: item.news_title || "",
          news_description: item.news_description || "",
          news_img: null,
          news_status: item.news_status?.toString() ?? "1",
          news_date: item.news_date || "",
        },
        previewImage: item.news_img
          ? `${process.env.REACT_APP_API_BASE_URL}/uploads/news/${item.news_img}`
          : null,
        error: "",
      });
    } else {
      this.resetForm();
    }

    modal.show();
  };

  /** ✅ Submit add/update */
  handleSubmit = async (e) => {
    e.preventDefault();
    const { formData, modalMode } = this.state;

    if (!formData.admin_id) {
      return this.setState({ error: "Admin ID is required." });
    }
    if (!formData.news_title) {
      return this.setState({ error: "News title is required." });
    }
    if (formData.news_status === "") {
      return this.setState({ error: "Status is required." });
    }

    const data = new FormData();
    data.append("admin_id", formData.admin_id);
    data.append("news_title", formData.news_title);
    data.append("news_description", formData.news_description);
    data.append("news_status", formData.news_status);
    data.append("news_date", formData.news_date);
    if (formData.news_img) {
      data.append("news_img", formData.news_img);
    }

    this.setState({ submitting: true, error: "" });

    try {
      const token = localStorage.getItem("token");

      if (modalMode === "add") {
        await axios.post("/news", data, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        });
      } else {
        await axios.post(`/news/${formData.id}?_method=PUT`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        });
      }

      await this.fetchNews();

      const modal = window.bootstrap.Modal.getInstance(
        document.getElementById("newsModal")
      );
      if (modal) modal.hide();

      Swal.fire({
        icon: "success",
        title:
          modalMode === "add"
            ? "News added successfully!"
            : "News updated successfully!",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (err) {
      console.error(err);
      this.setState({
        error:
          err.response?.data?.message ||
          err.response?.data?.error ||
          "Error saving news.",
      });
    } finally {
      this.setState({ submitting: false });
    }
  };

  /** ✅ Confirm delete */
  confirmDelete = (id) => {
    this.setState({ deleteId: id });
    const modal = new window.bootstrap.Modal(
      document.getElementById("deleteModal")
    );
    modal.show();
  };

  /** ✅ Delete news */
  handleDelete = async () => {
    const { deleteId } = this.state;
    if (!deleteId) return;

    try {
      const token = localStorage.getItem("token");
      await axios.delete(`/news/${deleteId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      await this.fetchNews();

      const modal = window.bootstrap.Modal.getInstance(
        document.getElementById("deleteModal")
      );
      if (modal) modal.hide();

      Swal.fire({
        icon: "success",
        title: "News deleted successfully!",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Failed to delete news.",
      });
    }
  };

  render() {
    const {
      news,
      formData,
      error,
      loading,
      submitting,
      modalMode,
      previewImage,
    } = this.state;
    const baseUrl = axios.defaults.baseURL.replace("/api", "");
    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="row">
            <div className="col-lg-12">
              <div className="card shadow-none">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <ul className="breadcrumb mb-0">
                    <li className="breadcrumb-item">News</li>
                    <li className="breadcrumb-item active">List</li>
                  </ul>

                  <button
                    type="button"
                    className="btn btn-light-warning"
                    onClick={() => this.openModal("add")}
                  >
                    + New News
                  </button>
                </div>

                <div className="card-body">
                  {error && <div className="alert alert-danger">{error}</div>}

                  {loading ? (
                    <div className="text-center py-4">Loading...</div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Image</th>
                            <th>Admin Name</th>
                            <th>Title</th>
                            <th>Description</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {news.length > 0 ? (
                            news.map((item, index) => (
                              <tr key={item.id}>
                                <td>{index + 1}</td>
                                <td>
                                  {item.news_img ? (
                                    <img
                                      src={`${baseUrl}/uploads/news/${item.news_img}`}
                                      alt={item.news_title}
                                      style={{
                                        width: "60px",
                                        height: "60px",
                                        objectFit: "cover",
                                        borderRadius: "6px",
                                      }}
                                    />
                                  ) : (
                                    "N/A"
                                  )}
                                </td>
                                <td>{item.admin_id}</td>
                                <td>{item.news_title}</td>
                                <td>
                                  {item.news_description
                                    ? item.news_description.length > 80
                                      ? item.news_description.substring(0, 80) + "..."
                                      : item.news_description
                                    : "N/A"}
                                </td>
                                <td>
                                  {item.news_status === "1" || item.news_status === 1 ? (
                                    <span className="badge bg-success">Active</span>
                                  ) : (
                                    <span className="badge bg-danger">Inactive</span>
                                  )}
                                </td>
                                <td>
                                  <button
                                    className="btn btn-sm btn-light-success me-2"
                                    onClick={() => this.openModal("edit", item)}
                                  >
                                    <i className="ph ph-note-pencil"></i>
                                  </button>

                                  <button
                                    className="btn btn-sm btn-light-danger"
                                    onClick={() => this.confirmDelete(item.id)}
                                  >
                                    <i className="ph ph-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center">
                                No news found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add / Edit Modal */}
        <div className="modal fade" id="newsModal" tabIndex={-1}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <form onSubmit={this.handleSubmit}>
                <div className="modal-header">
                  <h5 className="modal-title">
                    {modalMode === "add" ? "Add News" : "Edit News"}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                  ></button>
                </div>

                <div className="modal-body">
                  <div className="row">
                    {/* Admin ID */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Admin Name</label>
                      <input
                        type="text"
                        name="admin_id"
                        className="form-control"
                        value={formData.admin_id}
                        onChange={this.handleChange}
                        required
                      />
                    </div>

                    {/* News Status */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Status</label>
                      <select
                        name="news_status"
                        className="form-select"
                        value={formData.news_status}
                        onChange={this.handleChange}
                        required
                      >
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>

                    {/* News Title */}
                    <div className="col-md-12 mb-3">
                      <label className="form-label">News Title</label>
                      <input
                        type="text"
                        name="news_title"
                        className="form-control"
                        value={formData.news_title}
                        onChange={this.handleChange}
                        required
                      />
                    </div>

                    {/* News Image */}
                    <div className="col-md-12 mb-3">
                      <label className="form-label">News Image</label>
                      <input
                        type="file"
                        name="news_img"
                        className="form-control"
                        accept="image/*"
                        onChange={this.handleChange}
                      />

                      {previewImage && (
                        <div className="mt-3">
                          <img
                            src={previewImage}
                            alt="Preview"
                            style={{
                              width: "120px",
                              height: "80px",
                              objectFit: "cover",
                              borderRadius: "6px",
                              border: "1px solid #ddd",
                            }}
                          />
                        </div>
                      )}
                    </div>

                    {/* News Description */}
                    <div className="col-md-12 mb-3">
                      <label className="form-label">News Description</label>
                      <textarea
                        name="news_description"
                        className="form-control"
                        rows="6"
                        value={formData.news_description}
                        onChange={this.handleChange}
                      ></textarea>
                    </div>

                    {error && (
                      <div className="col-md-12">
                        <div className="alert alert-danger">{error}</div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-light-danger"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>

                  <button
                    type="submit"
                    className="btn btn-light-primary"
                    disabled={submitting}
                  >
                    {submitting
                      ? "Saving..."
                      : modalMode === "add"
                      ? "Add"
                      : "Update"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Delete Modal */}
        <div className="modal fade" id="deleteModal" tabIndex={-1}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-danger">
              <div className="modal-body text-center p-4">
                <i className="ph ph-warning text-danger f-40 mb-3"></i>
                <h5>Are you sure?</h5>
                <p className="text-muted mb-4">This action cannot be undone.</p>

                <div className="d-flex justify-content-center gap-3">
                  <button
                    type="button"
                    className="btn btn-light-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="btn btn-light-danger"
                    onClick={this.handleDelete}
                  >
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default News;

